import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(private readonly title: Title) {}

  public setTitle(title: string): void {
    this.title.setTitle(title + ' - STALCRAFT.TRADE');
  }
}
